// extracted by mini-css-extract-plugin
module.exports = {"main-header-nav-sub-button":"styles__main-header-nav-sub-button__30r31","mainHeaderNavSubButton":"styles__main-header-nav-sub-button__30r31"};